import { useMemo } from "react";

const SegmentedControl = ({
  value,
  name,
  segments,
  callback,
  segmentWidth,
  triggered = false,
  pending = false,
  className = "",
  activeBg = "thumb-active"
}) => {
  const onInputChange = (name, value) => callback(value);

  // Where the thumb should slide to
  const selectedIndex = useMemo(
    () => Math.max(0, segments.findIndex(s => s.value === value)),
    [segments, value]
  );

  return (
    <div
      className={`controls-container col-12 ${segmentWidth ? segmentWidth : ""}`}
      style={{
        // expose index & count as CSS variables so we can animate with pure CSS
        ["--seg-count"]: segments.length,
        ["--seg-index"]: selectedIndex
      }}
    >
      <div className={`controls device col-12 ready ${className}`}>
        {/* Sliding thumb */}
        <div
          className={`seg-thumb ${triggered ? "thumb-triggered" : pending ? "thumb-pending" : activeBg}`}
          aria-hidden="true"
        />

        {/* Segments */}
        {segments?.map((item) => (
          <div
            key={item.value}
            className={`segment device py-3  ${
              triggered ? "triggered"
              : item.value === value || pending ? "active"
              : "inactive"
            } col`}
          >
            <p
              className={`col-12 px-0 bold ${
                item.value === value || triggered || pending ? "white-white" : "grey-blue"
              }`}
              htmlFor={item.label}
            >
              <input
                type="radio"
                value={item.value}
                id={name}
                name={name}
                onChange={() => onInputChange(name, item.value)}
                checked={item.value === value}
              />
              {item.label}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SegmentedControl;